import Vue from 'vue';

// import datePicker from 'vue2-datepicker';

import modal from './ModalComponent.vue';
import pagination from './PaginationComponent.vue';

Vue.component('modal', modal);
Vue.component('pagination', pagination);
// Vue.component('date-picker', datePicker);